import { gql, useQuery } from "@apollo/client";

export type UserFavorites = GatsbyTypes.IPDPlatform_UserFavorite[];

export const GET_FAVORITES = gql`
  query UserFavorites($userId: Int!) {
    userFavorites(userId: $userId) {
      id
      tearSheet {
        id
        title
        type
        url
        reports {
          id
          reportDate
          conclusion
          summary
          url
        }
        drug {
          id
          ingredient
        }
        region {
          id
          name
          code
        }
      }
    }
  }
`;

export const useGetFavorites = ({ userId, skip = false }: { userId: string; skip?: boolean }): any => {
  const { data, error, loading } = useQuery(GET_FAVORITES, {
    skip,
    variables: { userId: parseInt(userId) },
  });
  return { data, error, loading };
};
